var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9 1.97998H5.09998C3.41998 1.97998 1.97998 3.41998 1.97998 5.09998V18.9C1.97998 20.58 3.41998 22.02 5.09998 22.02H18.9C20.58 22.02 22.02 20.58 22.02 18.9V5.09998C22.02 3.41998 20.58 1.97998 18.9 1.97998ZM8.69998 7.19998L12.72 11.58C12.9 11.82 12.9 12.18 12.72 12.42L8.69998 16.8C8.45998 17.04 8.03998 17.1 7.79998 16.86C7.61998 16.68 7.55998 16.5 7.55998 16.38C7.55998 16.2 7.61998 16.02 7.73998 15.9L11.34 12L7.73998 8.09998C7.49998 7.79998 7.49998 7.43998 7.79998 7.13998C8.03998 6.89998 8.45998 6.95998 8.69998 7.19998ZM12.24 7.19998L16.26 11.58C16.5 11.82 16.5 12.18 16.26 12.42L12.24 16.8C12 17.04 11.64 17.1 11.34 16.86C11.22 16.68 11.16 16.5 11.16 16.38C11.16 16.2 11.22 16.02 11.28 15.9L14.88 12L11.28 8.09998C11.04 7.79998 11.1 7.43998 11.34 7.13998C11.64 6.89998 12 6.95998 12.24 7.19998Z",
    fill: "#7688A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFull);
export default __webpack_public_path__ + "static/media/sidebarFull.d4a780ba521bb94314d874dc94d2dd42.svg";
export { ForwardRef as ReactComponent };